var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('iframe',{attrs:{"target":"_parent","src":"http://159.65.114.35:8001/status/bot","width":"100%","height":"100","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }